/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_IngredientsInputs */

const en_cook_ingredients = /** @type {(inputs: Cook_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredients`)
};

const de_cook_ingredients = /** @type {(inputs: Cook_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten`)
};

/**
* | output |
* | --- |
* | "Ingredients" |
*
* @param {Cook_IngredientsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_ingredients = /** @type {((inputs?: Cook_IngredientsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_IngredientsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_ingredients(inputs)
	return en_cook_ingredients(inputs)
});